import { useCallback } from 'react'
import i18n from 'i18next'
import { useTranslation } from 'react-i18next'
import { type PieceWithoutId } from '../types/Piece.js'

function getPieceStatusDescription(status: string | null): string {
  const shortStatusKey = `trackTrace.shortStatus.${status}`

  if (i18n.exists(shortStatusKey)) {
    return shortStatusKey
  }

  const statusKey = `trackTrace.status.${status}`

  if (i18n.exists(statusKey)) {
    return statusKey
  }

  return `trackTrace.category.${status}`
}

export const usePieceStatusDescription = (): ((piece: PieceWithoutId) => string) => {
  const { t } = useTranslation()

  const statusDescription = useCallback(
    (status: string | null) => {
      const statusKey = getPieceStatusDescription(status)
      return i18n.exists(statusKey) ? t(statusKey) : statusKey
    },
    [t]
  )

  return useCallback(
    (piece: PieceWithoutId) => {
      const { status, category } = piece
      const pieceStatus =
        status === 'PARCEL_SCANNED_AT_RETURN_HUB' && category === 'DELIVERED' ? 'RETURN_PACKAGE_DELIVERED' : status

      return statusDescription(pieceStatus)
    },
    [statusDescription]
  )
}
